
<b-container>
  <b-row class="mb-3">
    <b-col>
      <div class="d-flex justify-content-between">
        <b-button variant="primary" v-on:click="selectCategory(currentCategory.parent_category_id)" v-if="!!currentCategory.parent_category_id">
          <b-icon-chevron-double-left class="mr-1"></b-icon-chevron-double-left>
          {{parentCategory.name}}
        </b-button>
        <p>&nbsp;</p>
      </div>
    </b-col>
    <b-col>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" v-on:click="goToQuote()">
          <b-icon-file-earmark class="mr-1"></b-icon-file-earmark>
          Go To Quote
        </b-button>
        <p>&nbsp;</p>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <b-button block variant="secondary" size="lg" class="mb-3">
        <h2>{{currentCategory.name}}</h2>
      </b-button>
    </b-col>
  </b-row>
</b-container>
